// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fourth-page {

    padding: 10mm;
    padding-bottom: 0;

}`, "",{"version":3,"sources":["webpack://./src/views/admin/default/Report/FourthPage/index.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,iBAAiB;;AAErB","sourcesContent":[".fourth-page {\n\n    padding: 10mm;\n    padding-bottom: 0;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
